export default "__VITE_ASSET__CFIPUB4R__"